import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const blogArticleCarouselInputs = [
  {
    name: "title",
    type: "string",
    required: false,
  },
  {
    name: "ctaLabel",
    type: "string",
    required: false,
  },
  {
    name: "ctaUrl",
    type: "url",
    required: false,
  },
  {
    name: "articles",
    type: "list",
    required: true,
    defaultValue: [],
    subFields: [
      {
        name: "article",
        type: "reference",
        model: "blog-single-article-section-model",
      },
    ],
  },
] as const satisfies Inputs;

export const BlogArticleCarouselComponent: RegisteredComponent = {
  name: "BlogArticleCarousel",
  component: dynamic(async () =>
    withValidation(
      blogArticleCarouselInputs,
      (await import("./BlogArticleCarousel")).BlogArticleCarousel,
      "BlogArticleCarousel"
    )
  ),
  inputs: blogArticleCarouselInputs,
};
